
import authReducer from './reducers/authReducer'
const rootReducers = {
    auth: authReducer,
    }
export default rootReducers